import { FieldOrigin } from './enums/FieldOrigin';
import { Field } from 'ts-force';

interface AuditFields {
  createdAt?: string;
  createdBy?: string;
  updatedBy?: string;
  updatedAt?: string;
}

export type Optional<T> = T | null | undefined;

export enum SfdcDisplayType {
  ADDRESS = 'ADDRESS',
  BOOLEAN = 'BOOLEAN',
  CURRENCY = 'CURRENCY',
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  EMAIL = 'EMAIL',
  GEOLOCATION = 'GEOLOCATION',
  TEXTAREA = 'TEXTAREA',
  LONGTEXTAREA = 'LONGTEXTAREA',
  REFERENCE = 'REFERENCE',
  MULTIPICKLIST = 'MULTIPICKLIST',
  NUMBER = 'NUMBER',
  PERCENT = 'PERCENT',
  PHONE = 'PHONE',
  PICKLIST = 'PICKLIST',
  COMBOBOX = 'COMBOBOX',
  STRING = 'STRING',
  TIME = 'TIME',
  URL = 'URL',
  INTEGER = 'INTEGER',
  DOUBLE = 'DOUBLE',
  ID = 'ID',
  ENCRYPTEDSTRING = 'ENCRYPTEDSTRING',
  UNKNOWN = 'Unknown', // This is not a salesforce type, defined by MP
}

export interface SweepFieldBaseDto extends AuditFields {
  id?: string;
  objectName: string;
  /** @deprecated use SFFieldInterface.sfField.label instead */
  sweepFieldName?: string;
  /** @deprecated use SFFieldInterface.type instead */
  fieldType: SweepFieldTypes;
  /** @deprecated  */
  properties: SweepFieldProperties;
  /** @deprecated use SFFieldInterface.name instead */
  sfFieldName?: string;
  description?: string;
  helpText?: string;
  isRequired: boolean;
  origin?: FieldOrigin;
  pinToFunnelMap?: string;
  isCompound?: boolean;
  rollup?: Rollup;
  isLeadingCandidate?: boolean;
  readVersion?: ReadOnlyField;
  compoundFieldId?: string;
  sfDisplayType: SfdcDisplayType;
}

export type SFFieldInterface = SweepFieldBaseDto & { sfField: Field };

export type CreateFieldFieldInterfaceDto = Omit<
  SweepFieldBaseDto,
  'properties' | 'fieldType' | 'id'
> &
  Partial<Pick<SweepFieldBaseDto, 'properties' | 'fieldType' | 'id'>> & {
    sfField?: Pick<
      Field,
      'picklistValues' | 'defaultValueFormula' | 'defaultValue' | 'scale' | 'precision' | 'length'
    >;
  };

export type EditFieldFieldInterfaceDto = CreateFieldFieldInterfaceDto & {
  id: string;
};

export interface SweepField extends SFFieldInterface {
  objectNames?: string[];
}
export type SweepFieldsMap = { [fieldId: string]: SweepField };

// TODO use SweepFieldsSummary from BE (in sweep_field.interface, move to shared with client if possible)
export type SweepFieldSummary = Pick<
  SweepField,
  | 'id'
  | 'sweepFieldName'
  | 'sfFieldName'
  | 'objectName'
  | 'sfDisplayType'
  | 'objectNames'
  | 'fieldType'
> & {
  isRestrictedPicklist?: boolean;
  sfField: Pick<Field, 'type' | 'label' | 'name' | 'referenceTo'>;
};

export type SweepFieldsSummaryMap = {
  [sweepFieldId: string]: SweepFieldSummary;
};
